export const environment = {
  production: true,
  apiUrl: 'https://crmapi.invontolabs.com/api',
  hubUrl: 'https://crmapi.invontolabs.com/signalHub',
  stripePublicKey: 'pk_live_o5cn9SkG6s93PpLa6hLLWjRb00pqCmIpfS'
};
